import React from 'react'
import { getCookie } from '../../utils'
import urls from '../../url'

export const ApplicationContext = React.createContext({
  language: 'en',
  handleLanguageChange: () => { },
  user: {},
  handleUserChange: () => { },
  cart: [],
  handleCartChange: () => (e) => { }
})

class ContextWrapper extends React.Component {
  constructor(props) {
    super()

    // handlers
    this.handleLanguageChange = (language) => (e) => {
      this.setState({ language })
      document.cookie = `mblang=${language}`
    }
    this.handleUserChange = (user) => (e) => {
      this.setState({ user })
    }
    /**
     *
     * @param {*} action Action to be performed
     * @param {*} payload  Payload
     */
    this.handleCartChange = (action, payload) => (e) => {
      const cart = this.state.cart
      const newCart = []
      let matched = false
      switch (action) {
        case 'ADD':
          try {
            if (window.gtag) {
              window.gtag('event', 'add_to_cart', {
                currency: 'INR',
                value: payload.denomination,
                items: [{
                  id: payload.brandId,
                  name: payload.businessName,
                  price: payload.denomination,
                  quantity: 1
                }]
              })
            }
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                currency: 'INR',
                value: payload.denomination,
                content_ids: [payload.brandId],
                content_name: payload.brandName,
                content_type: 'product',
                contents: [{
                  id: payload.brandId,
                  quantity: 1
                }]
              })
            }
          } catch (error) {
            console.error(error)
          }
          cart.forEach((e, i) => {
            if (e.brand) {
              if (e.brandId === payload.brandId) {
                if (e.denomination === payload.denomination) {
                  newCart.push({
                    name: e.name,
                    brand: true,
                    image: e.image,
                    brandId: e.brandId,
                    denomination: e.denomination,
                    quantity: e.quantity + payload.quantity,
                    businessName: e.businessName,
                    discount: e.discount,
                    superCashbackPercent: e.superCashbackPercent,
                    superCashback: e.superCashback
                  })
                  matched = true
                } else {
                  newCart.push({
                    name: e.name,
                    brand: true,
                    image: e.image,
                    brandId: e.brandId,
                    denomination: e.denomination,
                    quantity: e.quantity,
                    businessName: e.businessName,
                    discount: e.discount,
                    superCashbackPercent: e.superCashbackPercent,
                    superCashback: e.superCashback
                  })
                }
              } else {
                newCart.push({
                  name: e.name,
                  brand: true,
                  brandId: e.brandId,
                  image: e.image,
                  denomination: e.denomination,
                  quantity: e.quantity,
                  businessName: e.businessName,
                  discount: e.discount,
                  superCashbackPercent: e.superCashbackPercent,
                  superCashback: e.superCashback
                })
              }
            }
          })
          if (!matched) {
            newCart.push({
              name: payload.name,
              brand: true,
              image: payload.image,
              brandId: payload.brandId,
              denomination: payload.denomination,
              quantity: payload.quantity,
              businessName: payload.businessName,
              discount: payload.discount,
              superCashbackPercent: payload.superCashbackPercent,
              superCashback: payload.superCashback
            })
          }
          break
        case 'SUB':
          try {
            window.gtag('event', 'remove_from_cart', {
              currency: 'INR',
              value: payload.denomination,
              items: [{
                id: payload.brandId,
                name: payload.businessName,
                price: payload.denomination,
                quantity: 1
              }]
            })
          } catch (error) {
            console.log(error)
          }
          cart.forEach((e, i) => {
            if (e.brand) {
              if (e.brandId === payload.brandId) {
                if (e.denomination === payload.denomination) {
                  const quantity = e.quantity - payload.quantity
                  if (quantity > 0) {
                    newCart.push({
                      brand: true,
                      brandId: payload.brandId,
                      denomination: payload.denomination,
                      image: e.image,
                      quantity: quantity,
                      businessName: payload.businessName,
                      discount: payload.discount,
                      name: e.name,
                      superCashbackPercent: e.superCashbackPercent,
                      superCashback: e.superCashback
                    })
                  }
                } else {
                  newCart.push({
                    brand: true,
                    brandId: e.brandId,
                    denomination: e.denomination,
                    image: e.image,
                    quantity: e.quantity,
                    businessName: e.businessName,
                    discount: e.discount,
                    name: e.name,
                    superCashbackPercent: e.superCashbackPercent,
                    superCashback: e.superCashback
                  })
                }
              } else {
                newCart.push({
                  brand: true,
                  brandId: e.brandId,
                  denomination: e.denomination,
                  quantity: e.quantity,
                  image: e.image,
                  businessName: e.businessName,
                  discount: e.discount,
                  superCashbackPercent: e.superCashbackPercent,
                  superCashback: e.superCashback
                })
              }
            }
          })
          break
      }
      this.setState({ cart: newCart })
      const cartBuffer = Buffer.from(JSON.stringify(newCart))
      window.localStorage.setItem('mbcart', cartBuffer.toString('base64'))
      const cognitoId = getCookie('cognitoId')
      const token = getCookie('token')
      if (cognitoId) {
        window.fetch(`${urls.meribachat}/user/cart`, {
          method: 'POST',
          body: JSON.stringify({
            cart: cartBuffer.toString('base64'),
            cognitoId: cognitoId
          }),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }).then(() => { }).catch(() => { })
      }
    }

    // States
    this.state = {
      language: props.lang,
      handleLanguageChange: this.handleLanguageChange,
      user: {},
      handleUserChange: this.handleLanguageChange,
      cart: [],
      handleCartChange: this.handleCartChange
    }
  }

  componentDidMount() {
    // Load cart from the local storage
    const cartHex = window.localStorage.getItem('mbcart')
    const cognitoId = getCookie('cognitoId')
    const token = getCookie('token')
    if (cartHex === null) {
      this.setState({ cart: [] })
      const cartBuffer = Buffer.from(JSON.stringify([]))

      window.localStorage.setItem('mbcart', cartBuffer.toString('base64'))
    } else {
      const cartBuffer = Buffer.from(cartHex, 'base64')
      try {
        this.setState({ cart: JSON.parse(cartBuffer.toString('utf8')) })
      } catch (e) {
        this.setState({ cart: [] })
        const cartBuffer = Buffer.from(JSON.stringify([]))
        window.localStorage.setItem('mbcart', cartBuffer.toString('base64'))
      }
    }
    // Load the cart from backend
    if (cognitoId) {
      window.fetch(`${urls.meribachat}/user/cart?cognitoId=${cognitoId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then((res) => {
          if (res.status === 200) {
            return res.json()
          }
        })
        .then((msg) => {
          window.localStorage.setItem('mbcart', msg.cart)
          const cartBuffer = Buffer.from(msg.cart, 'base64')
          this.setState({ cart: JSON.parse(cartBuffer.toString('utf-8')) })
        })
        .catch(() => { })
    }
  }

  render() {
    return (
      <>
        <ApplicationContext.Provider value={this.state}>
          {this.props.children}
        </ApplicationContext.Provider>
      </>
    )
  }
}

export default ContextWrapper
